import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.embedded-marketplace.title',
		defaultMessage: 'Also available via the Atlassian marketplace',
		description: 'The title of the embedded marketplace section',
	},
	subtitle: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.embedded-marketplace.subtitle',
		defaultMessage: '(Full support for third parties coming soon)',
		description: 'The details to the title of the embedded marketplace section',
	},
	browseMarketplaceLinkText: {
		id: 'software-code-code-page.pages.connection-page.ready-to-connect.embedded-marketplace.browse-marketplace-link-text',
		defaultMessage: 'Browse the Atlassian Marketplace for more code integrations',
		description: 'Link to browse and install more marketplace apps',
	},
});
